<template>
  <div>
    <vs-row>
      <vs-col vs-lg="6" vs-sm="12" class="p-2">
        <div class="light_grey_holder p-4">
          <h5 class="mb-4">Details</h5>
          <vs-row>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>Name:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.brand_company_name }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>Email:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.email }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>Phone:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.phone }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>School Type:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.customer_type }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>School Address:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.address1 }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>Plan Active:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.subscription_plan }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>Website:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.website }}</p>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
              <label>Created:</label>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
              <p>{{ school_details.created_at }}</p>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" class="p-2">
        <div class="light_grey_holder p-4">
          <h5 class="mb-4">Updates</h5>
          <ul class="calendar_update_holder vertical_scrollbar">
            <li>
              <div class="icon_holder">
                <vs-icon icon-pack="feather" icon="icon-calendar" />
              </div>
              <div class="pl-4">
                <h5>Calendar Linked Calls1</h5>
                <small>25 Days Ago</small>
              </div>
            </li>
            <li>
              <div class="icon_holder">
                <vs-icon icon-pack="feather" icon="icon-calendar" />
              </div>
              <div class="pl-4">
                <h5>Calendar Linked Calls1</h5>
                <small>25 Days Ago</small>
              </div>
            </li>
            <li>
              <div class="icon_holder">
                <vs-icon icon-pack="feather" icon="icon-calendar" />
              </div>
              <div class="pl-4">
                <h5>Calendar Linked Calls1</h5>
                <small>25 Days Ago</small>
              </div>
            </li>
            <li>
              <div class="icon_holder">
                <vs-icon icon-pack="feather" icon="icon-calendar" />
              </div>
              <div class="pl-4">
                <h5>Calendar Linked Calls1</h5>
                <small>25 Days Ago</small>
              </div>
            </li>
            <li>
              <div class="icon_holder">
                <vs-icon icon-pack="feather" icon="icon-calendar" />
              </div>
              <div class="pl-4">
                <h5>Calendar Linked Calls1</h5>
                <small>25 Days Ago</small>
              </div>
            </li>
            <li>
              <div class="icon_holder">
                <vs-icon icon-pack="feather" icon="icon-calendar" />
              </div>
              <div class="pl-4">
                <h5>Calendar Linked Calls1</h5>
                <small>25 Days Ago</small>
              </div>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import { getSchoolInfo } from '@/api/setting'
export default {
  mounted () {
    this.fetchSchoolDetails()
  },
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      school_details: null
    }
  },
  methods: {
    async fetchSchoolDetails () {
      try {
        const { data } = await getSchoolInfo(this.customer_id)
        this.school_details = data.data.platform_customer
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
